import script from "./user-access.vue?vue&type=script&lang=js"
export * from "./user-access.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__